import React,{ useState, useEffect } from 'react';
import {AiOutlineUserAdd} from 'react-icons/ai';
import EditIconButton from "../../components/IconButtons/EditIconButton";
import DeleteIconButton from "../../components/IconButtons/DeleteIconButton";
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { useStateContext } from '../../contexts/ContextProvider';
import { useTicketsMutations } from '../../hooks';
import {getTickets} from "../../services/Tikets";
import {formatDate} from '../../formatters/date';
import DataTable from 'react-data-table-component';
import { NuevoTicketsLF } from '../../components';
import { FolderIcon, UserIcon } from '@heroicons/react/24/solid';

const NavButton = ({ title, customFunc, icon, color, texto }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ backgroundColor: color}}
      className="relative text-xl  text-white rounded-lg p-3 hover:bg-light-gray"
    >
      <div className="flex flex-row justify-between items-center">
        <div>{icon}</div>
        <div><p className="text-xs ">{texto}</p></div>
      </div>
    
    </button>

  </TooltipComponent>
);

const Tickets = () => {
  const { currentColor, handleClick, isClicked } = useStateContext();
  const {removeTicket} = useTicketsMutations();
  const [sucursalesData, setSucursalesData] = useState([]);
  const [laSucursal, setLaSucursal] = useState("");
  const [estado, setEstado] = useState('ALL');
  const [tipo, setTipo] = useState('ALL');
  const [numTicketFiltro, setNumTicketFiltro] = useState("");
  const [numInternoFiltro, setNumInternoFiltro] = useState("");


  useEffect(()=>{
    const fetchData = async () => {
      const misSucursales = await getTickets(tipo,estado, numTicketFiltro, numInternoFiltro);
      setSucursalesData(misSucursales);
    };
    fetchData();
  },[]);

  useEffect(()=>{
    const fetchData = async () => {
      const misSucursales = await getTickets(tipo,estado, numTicketFiltro, numInternoFiltro);
      setSucursalesData(misSucursales);
    };
    fetchData();
  },[tipo,estado, numTicketFiltro, numInternoFiltro]);

const handleChangeEstado = (e) =>{
  setEstado( e.target.value );
}

const handleChangeTipo = (e) =>{
  setTipo( e.target.value );
}

const handleChangeNumTicketFiltro = (e) =>{
  setNumTicketFiltro( e.target.value );
}

const handleChangeNumInternoFiltro = (e) =>{
  setNumInternoFiltro( e.target.value );
}

  const handleEdit = (sucursalData) => {
    setLaSucursal(sucursalData);
    handleClick('nuevoTicket');
  };

  const handleEliminar = async (row) => {
    setSucursalesData((prevData) => prevData.filter((item) => item._id !== row._id));
    await removeTicket.mutateAsync(row._id);
    setSucursalesData((prevData) =>(prevData));
  };

  const handleRefreshDataTable = (opcion) => {
    if (opcion==="REFRESH"){
      const fetchData = async () => {
        const losFiados = await getTickets(tipo,estado);
        setSucursalesData(losFiados);
      };
      fetchData();
    }

  };

const customStyles = {
  table: {
    style: {
      backgroundColor: 'white',
      borderRadius: '8px',
    },
  },
  head: {
    style: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#2F336A',
      backgroundColor: '#F2F5FE',
      borderBottom: '1px solid #D9E1F2',
    },
  },
  headRow: {
    style: {
      minHeight: '48px',
      borderBottomWidth: '1px',
    },
  },
  headCells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
      whiteSpace: 'nowrap',
    },
  },
  rows: {
    style: {
      fontSize: '13px',
      backgroundColor: 'white',
      minHeight: '52px',
      borderBottom: '1px solid #F3F4F6',
      transition: 'background-color 0.2s ease-in-out',
    },
    highlightOnHoverStyle: {
      backgroundColor: '#F9FAFB',
      borderBottomColor: '#E5E7EB',
      outline: 'none',
    },
  },
  cells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
    },
  },
};

  const columns = [
    {
      name: '',
      width: '40px',
      cell: (row) => ( <EditIconButton onClick={() => handleEdit(row)} /> )
    },
    {
      name: '',
      width: '40px',
      cell: (row) => ( <DeleteIconButton onClick={() => handleEliminar(row)} /> )
    },
    {
      name: 'Fecha Creación',
      width: '160px',
      selector: row => formatDate(row.fechaCreacion),
      sortable: true
    },
    {
      name: 'N° Ticket',
      width: '130px',
      selector: row => row.numTicket,
      sortable: true
    },
    {
      name: 'Tipo',
      width: '130px',
      selector: row => row.tipo,
      sortable: true
    },
    {
      name: 'Requerimiento',
      width: '300px',
      selector: row => row.requerimiento,
      sortable: true,
      cell: (row) => (
      <div className="flex items-center gap-2">
        <FolderIcon className="w-4 h-4 text-blue-500" />
        <span>{row.requerimiento}</span>
      </div>
      )
    },
      {
    name: 'Estado',
    width: '120px',
    selector: row => row.estado,
    sortable: true,
    cell: (row) => {
      let bgColor = '';
      switch (row.estado) {
        case 'Finalizado':
          bgColor = 'bg-green-100 text-green-700';
          break;
        case 'Pendiente':
          bgColor = 'bg-yellow-100 text-yellow-700';
          break;
        case 'Cancelado':
          bgColor = 'bg-red-100 text-red-700';
          break;
        default:
          bgColor = 'bg-gray-100 text-gray-700';
      }
      return (
        <div className={`text-xs px-2 py-1 rounded-full text-center ${bgColor}`}>
          {row.estado}
        </div>
      );
    }
  },
    {
      name: 'Observación',
      width: '300px',
      selector: row => row.observacion,
      sortable: true,
            cell: (row) => (
      <div className="flex items-center gap-2">

        <span>{row.observacion}</span>
      </div>
      )
    }
  ];

  return (
  <>
    <div className="mx-4 lg:mx-12 mt-4">
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                Tickets
              </p>
            </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-lg mt-2">
          <div className="flex justify-start items-center p-2 md:ml-6 md:mr-6 relative top-1">
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4 w-full">
              <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Tipo</label>
                  <select className="text-xs border border-gray-300 p-2 rounded" name="tipo" value={tipo}  onChange={handleChangeTipo}>   
                    <option value="ALL">Todos</option>
                    <option value="Taller">Taller</option>
                    <option value="Calidad">Calidad</option>  
                    <option value="Expeditor">Expeditor</option>    
                  </select>
              </div> 
              <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Estado</label>
                  <select className="text-xs border border-gray-300 p-2 rounded" name="estado" value={estado} onChange={handleChangeEstado}>   
                  <option value="ALL">Todos</option>
                  <option value="Pendiente">Pendiente</option>
                  <option value="Finalizado">Finalizado</option>
                  <option value="Cancelado">Cancelado</option>      
                  </select>
              </div>
              <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">N° Ticket</label>
                <input
                  type="text"
                  className="text-xs border border-gray-300 p-2 rounded"
                  placeholder="Ej: 12345"
                  value={numTicketFiltro}
                  onChange={handleChangeNumTicketFiltro}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">N° Interno Equipo</label>
                <input
                  type="text"
                  className="text-xs border border-gray-300 p-2 rounded"
                  placeholder="Ej: EQ-001"
                  value={numInternoFiltro}
                  onChange={handleChangeNumInternoFiltro}
                />
              </div>  
              <div className="flex flex-col justify-end">
                <NavButton title="Agregar Ticket" customFunc={() => { setLaSucursal(''); handleClick('nuevoTicket')} } color={currentColor} icon={<AiOutlineUserAdd />} texto={'Nuevo Ticket'} />
              </div>
          </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-lg items-end mt-4">
      <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
          <div className="flex flex-col">
              <DataTable
                columns={columns}
                data={sucursalesData}
                highlightOnHover
                pagination={true}
                striped
                className="border border-gray-300 rounded-lg shadow-sm"
                noHeader={true}
                selectableRowsHighlight
                customStyles={customStyles}
                noDataComponent={'No hay Tickets creados'}
              />
          </div>
      </div>
        </div>
     {isClicked.nuevoTicket && (<NuevoTicketsLF vecinoData={laSucursal} onChangeVecino={handleRefreshDataTable}/>)}

    </div>


</>
  );
};

export default Tickets;